export default __webpack_public_path__ + "static/kampaamo-2ab1d9778c24e354a89444aaf9598a57.jpeg";